import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { color, typography, space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

import { Label as BaseLabel } from './Input';

export default function ToggleSwitch({
  value = false,
  onChange,
  label,
  name,
  id,
  // eslint-disable-next-line no-shadow
  color = 'black.100',
  fontWeight = '500',
  margin,
  invertLabelPosition = false,
  disabled = false,
}) {
  return (
    <Wrapper m={margin}>
      <Label
        invertLabelPosition={invertLabelPosition}
        htmlFor={id}
        color={color}
        fontWeight={fontWeight}
        disabled={disabled}
      >
        {label}
      </Label>
      <Input
        id={id}
        type="checkbox"
        checked={value}
        onChange={onChange}
        name={name}
        disabled={disabled}
      />
      <InputLabel disabled={disabled} htmlFor={id} isChecked={value}>
        <ToggleButton />
      </InputLabel>
    </Wrapper>
  );
}

ToggleSwitch.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.string,
  invertLabelPosition: PropTypes.bool,
  disabled: PropTypes.bool,
  margin: PropTypes.string,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Montserrat';
  ${space};
`;

const Label = styled(BaseLabel)`
  ${color};
  ${typography};
  opacity: ${props => (props.disabled ? '0.4' : '1')};
  ${({ invertLabelPosition }) =>
    invertLabelPosition
      ? `
          margin: 0 0 0 8px;
          order: 1;
        `
      : `
          margin: 0 8px 0 0;
          order: 0;
        `}
`;

const Input = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
`;

const InputLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${props => (props.disabled ? 'auto' : 'pointer')};
  width: 36px;
  height: 20px;
  border-radius: 100px;
  position: relative;
  transition: 0.2s;
  margin: 0;
  opacity: ${props => (props.disabled ? '0.4' : '1')};
  background: ${props =>
    props.isChecked
      ? themeGet('colors.primary.100')(props)
      : themeGet('colors.black.60')(props)};
`;

const ToggleButton = styled.span`
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 45px;
  transition: 0.2s;
  background: ${themeGet('colors.white')};
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  ${Input}:checked + ${InputLabel} & {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
`;
